angular.module('picmonicng').factory('PrintAndGoService', [
  '$modal',
  'MarketOptionsConfig',
  'UserService',
  function ($modal, MarketOptionsConfig, UserService) {
    return {
      print: function (type, id, layout) {
        if (typeof atlasEvent !== 'undefined') {
          atlasEvent('click', 'print_go_' + type);
        }
        if (
          (!UserService.user.is_trial && !UserService.user.is_fap) ||
          MarketOptionsConfig.getMarketById(UserService.user.lead).is_beta
        ) {
          if (UserService.user.has_seen.print_go_terms) {
            window.open(
              '/api/v3/printable-picmonics?type=' + type + '&id=' + id + '&layout=' + layout,
              null,
              'noopener'
            );
          } else {
            var modal = $modal.open({
              templateUrl: '/templates/modals/print-go.html',
            });
            modal.result.then(function () {
              UserService.see('print_go_terms');
              window.open(
                '/api/v3/printable-picmonics?type=' + type + '&id=' + id + '&layout=' + layout,
                null,
                'noopener'
              );
            });
          }
        } else {
          $modal.open({
            templateUrl: '/templates/modals/print-go-upgrade.html',
            controller: [
              '$scope',
              'MarketOptionsConfig',
              function ($scope, MarketOptionsConfig) {
                $scope.upgrade = function () {
                  if (UserService.user.lead) {
                    window.location = MarketOptionsConfig.getMarketById(UserService.user.lead).pricing_url;
                  } else {
                    window.location = '/pricing';
                  }
                };
              },
            ],
          });
        }
      },
    };
  },
]);
